import axios from "axios"
import Loader from "components/Loader/Loader"
import React, { createContext, useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import secureLocalStorage from "react-secure-storage"
import { fetchData } from "utils/Common_api_functions"

const RolesContext = createContext()

export const usePermissionData = () => {
  return useContext(RolesContext)
}

export const AppContext = ({ children }) => {
  const [permissions, setPermissions] = useState([])
  const [loginStatus, setLoginStatus] = useState(false)

  const [loading, setloading] = useState(false)

  const location = useLocation()

  const auth_token = secureLocalStorage?.getItem("auth_token")

  useEffect(() => {
    if (permissions.length === 0) {
      getStaffInfo()
    }
  }, [auth_token])

  async function getStaffInfo() {
    const APIdata = await fetchData(setloading, "roles/get-permissions")
    if (APIdata?.success) {
      const parsed = JSON.parse(APIdata?.permissions)

      setPermissions(parsed)
      secureLocalStorage.setItem("permissions", parsed)
    }
  }

  const checkAccess = (mod_id, type) => {
    if (!permissions || !Array.isArray(permissions)) return false

    return permissions.some(permission => {
      return permission.id === mod_id && permission?.[type] == 1
    })
  }
  return (
    <RolesContext.Provider
      value={{
        permissions,
        checkAccess,
        loginStatus,
        setLoginStatus,
        getStaffInfo,
      }}
    >
      {loading && <Loader />}
      {children}
    </RolesContext.Provider>
  )
}
